import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RequestService } from '@pisci/requestManager';
import { AuthQuery } from 'libs/shared/request-manager/src/lib/auth.query';
import { EMPTY, finalize } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  private readonly fb = inject(FormBuilder);

  loading = false;
  errorMessage = '';

  readonly loginForm = this.fb.group({
    tenant_id: this.fb.control('', [Validators.required]),
    email: this.fb.control('', [Validators.required, Validators.email]),
    password: this.fb.control('', [Validators.required]),
  });

  constructor(
    private rm: RequestService,
    private authQuery: AuthQuery,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.authQuery.getValue().jwt) {
      this.router.navigateByUrl('products');
    }
  }

  login() {
    if (this.loading) {
      return;
    }

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.errorMessage = 'Bitte fülle alle Pflichtfelder korrekt aus.';
      return;
    }

    const tenantId = this.loginForm.controls.tenant_id.value?.trim() ?? '';
    const email = this.loginForm.controls.email.value?.trim() ?? '';
    const password = this.loginForm.controls.password.value ?? '';

    this.errorMessage = '';
    this.loading = true;
    this.rm.setTenantId(tenantId);
    this.rm
      .login({ email, password })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            this.errorMessage =
              'Login fehlgeschlagen. Bitte pruefe Mandant, E-Mail und Passwort.';
          } else {
            this.errorMessage =
              'Der Login ist aktuell nicht verfuegbar. Bitte versuche es erneut.';
          }

          return EMPTY;
        }),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe(() => {
        this.router.navigateByUrl('products');
      });
  }
}
